export class WFEVendorResultDto {
    vendorId: number;
    vendorCode: string;
    vendorName: string;
    vendorTypeCode: string;
    remitAddress: string; // NOTE: Can contain new line characters that needs to be replaced with breakline tags
    isActive: boolean;
    isBranchVendor: boolean;
    vendorBranchAssociationId: number;
    isPriorityVendor: boolean;
    vendorInstructions: string;
    hasNotes: boolean; // NOTE: Indicates if there is viewable notes for the vendor
    isEFTVendor: boolean;

    get displayRemitAddress(): string {
        return `${this.remitAddress.replace(/\r\n/g, '<br>')}`;
    }
}
